"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.specialSet = exports.smallSlideRange = exports.largeSlideRange = exports.itemsPerSet = exports.WIDGET = exports.SLIDER = void 0;
/* istanbul ignore file -- constants */
const itemsPerSet = exports.itemsPerSet = 5;
const specialSet = exports.specialSet = 3;
const smallSlideRange = exports.smallSlideRange = 295;
const largeSlideRange = exports.largeSlideRange = 850;
const WIDGET = exports.WIDGET = 'widget';
const SLIDER = exports.SLIDER = 'slider';
